/**
 * Type guard function that checks if a value is a function.
 * Returns true if the value is a function, false otherwise.
 *
 * @param value - The value to check
 * @returns True if the value is a function, false otherwise

 * ```
 */
export const IsFunction = <T extends (...args: any[]) => any>(
  value: unknown
): value is T => typeof value === "function"
